import { Badge } from "react-bootstrap";
import { BuilderFolderType } from "./types";
    
type FolderRowProps = {
    folder: BuilderFolderType;
    onClick?: React.Dispatch<React.SetStateAction<BuilderFolderType>>;
}

const iconClsName = (folder: BuilderFolderType) => {
    if (folder === 'Root') return "fa-regular fa-folders";
    return "fa-solid fa-folder";
}

const BuilderFolderRow = ({
    folder,
    onClick
}: FolderRowProps) => (
    <tr onClick={(e) => {onClick(folder)}}>
        <td>
            <i className={iconClsName(folder)}></i>
        </td>

        <td>{folder=='Root' ? "..." : `${folder} Documents`}</td>

        <td className="align-center"></td>

        <td>
            <Badge bg="secondary" text="dark" pill>{}</Badge>
        </td>
        <td></td>
    </tr>
)

export default BuilderFolderRow;